module.exports = __webpack_public_path__ + "static/rito.6e3da7ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/rito.png
// module id = 433
// module chunks = 35783957827783